import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';
import Icon from 'components/Icon';

const StyledIcon = styled(Icon)`
    fill: ${({ theme }) => theme.ColorBackgroundBrand};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;

function VideoPlayIcon({ small }: { small: boolean }) {
    return <StyledIcon type="PlayButton" size={small ? 16 : 24} />;
}

export default withErrorBoundary(VideoPlayIcon, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
